import { render, staticRenderFns } from "./TemplateUpload.vue?vue&type=template&id=496664b8&scoped=true&"
import script from "./TemplateUpload.vue?vue&type=script&lang=js&"
export * from "./TemplateUpload.vue?vue&type=script&lang=js&"
import style0 from "./TemplateUpload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TemplateUpload.vue?vue&type=style&index=1&id=496664b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496664b8",
  null
  
)

export default component.exports